export default "__VITE_ASSET__c37dc00e__"